import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue';
import { useRoute, useRouter } from 'vue-router';
import { ref, watch } from 'vue';
import { CheckIcon, ChevronDownIcon } from '@heroicons/vue/20/solid';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QueryDropdown',
    props: {
        filterKey: { type: String, required: true },
        filterOptions: { type: Array, required: true },
        by: { type: String, required: false, default: 'key' },
        disabled: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        searchPlaceholder: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const options = ref(__props.filterOptions);
        function updateOptions(newFilters) {
            options.value = newFilters;
        }
        watch(() => __props.filterOptions, updateOptions);
        const isOpen = ref(false);
        function trackOpenState(open) {
            if (isOpen.value !== open) {
                isOpen.value = open;
                if (!open) {
                    router.push({
                        query: {
                            ...route.query,
                            ...{
                                [__props.filterKey]: selectedOption.value?.key,
                                startIndex: 1,
                            },
                        },
                    });
                }
            }
        }
        function updateSelectedOption() {
            const filterOptionKey = route.query[__props.filterKey]?.toString().replace(/^-/, '');
            selectedOption.value = __props.filterOptions.find(({ key }) => key === filterOptionKey) || __props.filterOptions[0];
        }
        const selectedOption = ref(__props.filterOptions[0]);
        watch(() => [route.query, __props.filterOptions], () => {
            updateSelectedOption();
        }, { immediate: true });
        updateSelectedOption();
        const __returned__ = { $t, route, router, options, updateOptions, isOpen, trackOpenState, updateSelectedOption, selectedOption, get Listbox() { return Listbox; }, get ListboxButton() { return ListboxButton; }, get ListboxOption() { return ListboxOption; }, get ListboxOptions() { return ListboxOptions; }, get CheckIcon() { return CheckIcon; }, get ChevronDownIcon() { return ChevronDownIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
